import React, { createContext, useContext, useEffect, useState } from "react";

const ProfileCtx = createContext(null);
const KEY = "edusphere_profile_v1";

const todayStr = () => new Date().toISOString().slice(0, 10);

const defaultProfile = {
  name: "",
  level: "school",
  language: "english",
  streak: 0,
  lastActive: null,
  sessions: 0,
  storiesRead: 0,
  quizzesTaken: 0,
  pathsStarted: 0,
  bestQuiz: 0,
  onboarded: false,
};

export function ProfileProvider({ children }) {
  const [profile, setProfile] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      if (raw) return { ...defaultProfile, ...JSON.parse(raw) };
    } catch (e) {}
    return defaultProfile;
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(profile));
  }, [profile]);

  const update = (patch) => setProfile((p) => ({ ...p, ...patch }));

  const touch = () => {
    setProfile((p) => {
      const today = todayStr();
      if (p.lastActive === today) return p;
      const yesterday = new Date(Date.now() - 86400000).toISOString().slice(0, 10);
      const newStreak = p.lastActive === yesterday ? (p.streak || 0) + 1 : 1;
      return { ...p, lastActive: today, streak: newStreak };
    });
  };

  const incr = (key, by = 1) => setProfile((p) => ({ ...p, [key]: (p[key] || 0) + by }));

  const recordQuiz = (score, total) => {
    setProfile((p) => ({
      ...p,
      quizzesTaken: (p.quizzesTaken || 0) + 1,
      bestQuiz: Math.max(p.bestQuiz || 0, total ? Math.round((score / total) * 100) : 0),
    }));
  };

  return (
    <ProfileCtx.Provider value={{ profile, update, touch, incr, recordQuiz }}>
      {children}
    </ProfileCtx.Provider>
  );
}

export const useProfile = () => useContext(ProfileCtx);
